import { render, staticRenderFns } from "./buyDialog.vue?vue&type=template&id=499ebdb2&"
import script from "./buyDialog.vue?vue&type=script&lang=js&"
export * from "./buyDialog.vue?vue&type=script&lang=js&"
import style0 from "./buyDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports